module.exports = __webpack_public_path__ + "assets/img/bannerBg.3be65ee7.png";